import React, { useEffect, useRef, useState } from 'react';
import { List, Typography, Box, Divider, IconButton, useTheme } from '@mui/material';
import { useSelector } from 'react-redux';
import { useGetCommentsQuery } from '../commentApiSlice';
import { useParams } from 'react-router-dom';
import { selectCurrentUser } from '../../Auth/authSlice';
import CommentItem from './CommentItem';
import { groupCommentsByDate } from '../utility/groupCommentsByDate';
import StyledDateDivider from './StyledDateDivider';
import { SkeletonCommentList } from '../skeletons/skeletonCommentList';
import { KeyboardBackspace } from '@mui/icons-material';
import NoComments from './NoComments';
const CommentList = ({ setEditingComment }) => {
  const theme = useTheme();
  const user = useSelector(selectCurrentUser);
  const { empCode } = useParams();
  const { data: commentData, isLoading, error } = useGetCommentsQuery(empCode);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setLoading(true);
  }, [empCode]);

  useEffect(() => {
    if (commentData !== undefined) {
      setLoading(false);
    }
  }, [commentData]);
  const listRef = useRef(null);

  useEffect(() => {
    if (listRef.current) {
      listRef.current.scrollTop = listRef.current.scrollHeight;
    }
  }, [commentData]);

  const groupedComments = groupCommentsByDate(commentData);

  if (isLoading || loading) return <SkeletonCommentList />;
  if (error) return <p>Error loading feedbacks</p>;

  return (
    <Box
      sx={{
        height: '100%',
        width: '100%',
        boxShadow: 'none',
      }}
    >
      {commentData?.length === 0 ? (
        <NoComments />
      ) : (
        <List ref={listRef} sx={{ width: '100%', overflowY: 'auto', padding: 0, height: 'calc(100vh - 200px)' }}>
          {Object.entries(groupedComments).map(([date, comments]) => (
            <React.Fragment key={date}>
              <StyledDateDivider date={date} />
              {comments.map(comment => (
                <CommentItem key={comment._id} comment={comment} user={user} setEditingComment={setEditingComment} />
              ))}
            </React.Fragment>
          ))}
        </List>
      )}
    </Box>
  );
};

export default CommentList;
